import { createElement } from '@gn-audio/core/common/templating';
import { EcomDomainListComponent } from '../ecom-domain-list/ecom-domain-list.component';
import './ecom-domain-selector.component.scss';
import template from './ecom-domain-selector.component.html';
var EcomDomainSelectorComponent = /** @class */ (function () {
    function EcomDomainSelectorComponent() {
        var _this = this;
        this.onEcomDomainChange = function (ecomDomain) {
            _this.selectedEcomDomain = ecomDomain;
        };
        this.goToEcomDomain = function () {
            var hash = location.hash, pathname = location.pathname, search = location.search;
            var targetEcomUrl = "".concat(_this.selectedEcomDomain.url).concat(pathname).concat(search).concat(hash);
            window.location.href = targetEcomUrl;
        };
    }
    EcomDomainSelectorComponent.prototype.render = function (container, translations) {
        this.element = container.appendChild(createElement(template, {}, translations));
        this.goButton = this.element.querySelector('.ecom-domain-selector__button');
        this.goButton.addEventListener('click', this.goToEcomDomain);
        this.domainListComponent = new EcomDomainListComponent();
        this.domainListComponent.render(this.element.querySelector('.ecom-domain-selector__input-container'), this.onEcomDomainChange);
    };
    EcomDomainSelectorComponent.prototype.destroy = function () {
        var _a;
        this.domainListComponent.destroy();
        this.goButton.removeEventListener('click', this.goToEcomDomain);
        (_a = this.element) === null || _a === void 0 ? void 0 : _a.remove();
    };
    return EcomDomainSelectorComponent;
}());
export { EcomDomainSelectorComponent };
